// Z-Index scale
export const zIndex = {
  base: '0',
  below: '-1',
  header: '100',
  footer: '100',
  sidebar: '200',
  mainContent: '300',
  dropdown: '400',
  sticky: '500',
  tooltip: '600',
  modal: '700',
  toast: '800',
  loader: '900',
  overlay: '1000',
  priority: '5000',
  critical: '6000',
  emergency: '9999'
};
